export default __webpack_public_path__ + "static/media/payroll-feature-convenience.c48b4655.svg";